import React from 'react';
import { Form, useFormikContext } from 'formik';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { Button } from 'Components/frameworks/button/Button';
import { COLORS } from 'Components/utils/color/colors';
import { Confirmation } from 'Components/widgets/confirmation/Confirmation';
import { useAutoScrollToError } from 'Components/frameworks/formik/ScrollToErrorHook';
import { FORM_STATUS } from 'Components/widgets/event-form/eventForm.utils';
type EventFormFormProps = {
  isSending: boolean;
  formStatus: 'neutral' | 'success' | 'error';
  confirmation: EventFormResponseTranslations | {};
  children: Node;
};
export const EventFormForm = ({
  isSending,
  formStatus,
  confirmation,
  children,
}: EventFormFormProps) => {
  const formik = useFormikContext();
  useAutoScrollToError(formik);
  return (
    <Form data-testid="form">
      {children}
      <div
        className={classnames('mt-15', {
          'text-right': formStatus === FORM_STATUS.NEW,
          'flex justify-center': formStatus !== FORM_STATUS.NEW,
        })}
      >
        {formStatus === FORM_STATUS.NEW ? (
          <Button
            colorBg={COLORS.SAFFRON}
            colorBorder={COLORS.SAFFRON}
            data-testid="event-submit"
            isLoading={isSending}
            type="submit"
          >
            {t('eventForm.formButton')}
          </Button>
        ) : (
          <Confirmation {...confirmation} status={formStatus} />
        )}
      </div>
    </Form>
  );
};
